// https://vuex.vuejs.org/en/state.html

export default {
    barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
    barImage: 'https://demos.creative-tim.com/material-dashboard-pro/assets/img/sidebar-1.jpg',
    role: null,
    isParish: false,
    hasDelegations: false,
    admins: ['admin', 'superadmin'],
    staff: ['rd', 'dsc', 'ad', 'pd', 'td',
        'missionary', 'affiliate', 'parish-td', 'parish-missionary'],
    regional: ['rd', 'ad', 'pd'],
    dsc: ['dsc'],
    roleGroups: ['admins', 'staff', 'regional', 'dsc'],
    error: null,
    lastLocation: '',
    userLocations: null
};
